// src/components/OnlinePaymentApi.js
import axios from 'axios';

const createRazorpayOrder = async (amount) => {
  const token = localStorage.getItem("STITCHD_ID");

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/order/createOrder`,
      {
        amount: amount, // Amount should be in the smallest currency unit
        currency: "INR",
        payment_capture: 1, // Auto capture
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.data && response.data.id) {
      return response.data;
    } else {
      throw new Error('Invalid response from backend');
    }
  } catch (error) {
    console.error('Error creating Razorpay order:', error);
    throw error;
  }
};

export { createRazorpayOrder };
